import { Table } from 'pink-lava-ui';
import dayjs from 'dayjs';
import ResponsiveModal from '@/components/ui/modal/ResponsiveModal';
import EmptyPlaceholder from '@/components/ui/EmptyPlaceholder';
import { useBookingOnDemandInfoById } from '@/features/on-demand/api/queries';
import { Tag } from 'antd';
import { getStatusAttr } from '@/components/ui/utils';

interface OnDemandChangeLogsModalProps {
  isOpen: boolean;
  onClose: () => void;
  bookingId?: string;
}

const OnDemandChangeLogsModal = ({ isOpen, onClose, bookingId }: OnDemandChangeLogsModalProps) => {
  const { data: bookingInfo, isLoading } = useBookingOnDemandInfoById(bookingId, isOpen);

  const changeLogList = bookingInfo?.data?.logs || [];

  return (
    <ResponsiveModal
      title={'Riwayat Perubahan'}
      open={isOpen}
      centered
      width={706}
      onCancel={onClose}
      footer={<></>}
      fullscreenMaxBreakpoint="md"
    >
      <div className="hidden md:block overflow-auto max-h-[calc(100dvh-140px)]">
        <Table
          loading={isLoading}
          size="small"
          dataSource={changeLogList}
          rowKey={'ulid'}
          scroll={{
            x: 640,
          }}
          pagination={false}
          columns={[
            {
              title: 'Tanggal & Waktu',
              dataIndex: 'created_at',
              render: (value: string) => dayjs(value).format('DD MMMM YYYY HH:mm:ss'),
              width: 200,
            },
            {
              title: 'Status',
              dataIndex: 'action',
              width: 150,
              render: (text: string) => (
                <Tag color={getStatusAttr(text).color} bordered={false} className={`text-sm! mr-0! font-nunito!`}>
                  {getStatusAttr(text).label}
                </Tag>
              ),
            },
            {
              title: 'Catatan',
              dataIndex: 'notes',
              render: (text: string) => text || '-',
            },
          ]}
        />
      </div>
      <div className="flex md:hidden space-y-2 flex-col overflow-auto p-4">
        {!changeLogList || changeLogList.length === 0 ? (
          <EmptyPlaceholder title="Riwayat Perubahan" />
        ) : (
          <>
            {changeLogList?.map(item => (
              <div key={item.ulid} className="border border-gray-400 rounded-xl last:mb-2">
                <div className="flex flex-row items-center #FAFAFB rounded-tl-xl rounded-tr-xl justify-evenly p-2 border-b border-gray-400 bg-gray-100">
                  <div className="text-sm text-center flex-1">
                    {dayjs(item.created_at).format('DD MMMM YYYY HH:mm:ss')}
                  </div>
                  <div className="bg-gray-400 h-[32px] w-[1px] mx-1" />
                  <div className="text-sm text-center flex-1">{item.action || '-'}</div>
                </div>
                <div className="p-3">{item.notes || '-'}</div>
              </div>
            ))}
          </>
        )}
      </div>
    </ResponsiveModal>
  );
};

export default OnDemandChangeLogsModal;
